import type { DataStore } from "../../Data/Store"
import { AccountApi } from "../../Types/Generated/LogbookApi/AccountApi"
import type { IAccountUserLevel } from "../../Types/Generated/LogbookModel/AccountUser"
import type { ISuccessResponse } from "../../Types/Generated/LogbookServer/SuccessResponse"

export interface AccountUserWriterIds {
  accountId: number;
}

export interface AccountUserWriters {
  updateAccountUserLevel: (userId: number, accountLevel: IAccountUserLevel) => Promise<ISuccessResponse>;
  removeAccountUser: (userId: number) => Promise<ISuccessResponse>;
}

export function createStoreAccountUserWriters(
  store: DataStore,
  ids: AccountUserWriterIds,
): AccountUserWriters {
  const refresh = async () => {
    await store.fetchQuery("AccountUser", { accountId: ids.accountId });
  };
  return {
    async updateAccountUserLevel(userId, accountLevel) {
      const current = store.getEntity("AccountUser", userId);
      const response = await store.mutate<ISuccessResponse>({
        optimistic: current
          ? { upsert: { AccountUser: [{ ...current, accountLevel }] } }
          : undefined,
        request: (client) =>
          new AccountApi(client).account.updateUserLevel({ params: { userId }, body: { accountLevel } }).call(),
      });
      await refresh();
      return response;
    },
    async removeAccountUser(userId) {
      const response = await store.mutate<ISuccessResponse>({
        optimistic: { remove: { AccountUser: [userId] } },
        request: (client) =>
          new AccountApi(client).account.removeUser({ params: { userId } }).call(),
      });
      await refresh();
      return response;
    },
  };
}
